document.addEventListener("DOMContentLoaded", function() {
    function addStartShoppingButton() {
        // Look for the "No wishes yet" message
        const wishlistNoItem = document.querySelector(".wishlsitnoitem p");
        
        if (wishlistNoItem && wishlistNoItem.textContent.includes("No wishes yet.")) {
            // Check if the button already exists
            if (!document.querySelector(".start-shopping-button")) {
                // Create the new button
                const startShoppingButton = document.createElement("button");
                startShoppingButton.type = "button";
                startShoppingButton.name = "start-shopping";
                startShoppingButton.className = "product-form__submit button button--full-width button--primary-yellow start-shopping-button"; // Apply the same classes as the "Add to cart" button
                startShoppingButton.innerHTML = "<span>Start Shopping</span>";

                // Add click event to navigate to the shopping page
                startShoppingButton.addEventListener("click", function() {
                    window.location.href = "https://lectricebikes.com/collections/shop-all-lectric-ebikes-products";
                });

                // Insert the button underneath the "No wishes yet" message
                const wishlistNoItemParent = wishlistNoItem.parentElement;
                wishlistNoItemParent.appendChild(startShoppingButton); // Insert after the text
            }
        }
    }

    // Initial check for "No wishes yet" message
    addStartShoppingButton();

    // Observe changes in the body for wishlist item removal
    const targetNode = document.body;

    const observer = new MutationObserver(function(mutationsList) {
        for (let mutation of mutationsList) {
            if (mutation.type === 'childList') {
                // Recheck for the "No wishes yet" message when any changes occur
                addStartShoppingButton();

                // Check if the modal with id "sewp-engine-popupinr" appears
                const modal = document.getElementById("sewp-engine-popupinr");
                if (modal && modal.style.display !== "none") {
                    // If modal appears, run the same listener logic
                    addStartShoppingButton();
                }
            }
        }
    });

    // Configure the observer
    observer.observe(targetNode, { childList: true, subtree: true });

    // Extra: Ensure it checks if the modal is already visible on page load
    const modalCheckOnLoad = document.getElementById("sewp-engine-popupinr");
    if (modalCheckOnLoad && modalCheckOnLoad.style.display !== "none") {
        addStartShoppingButton();
    }
});